<sb-modal-header [modalTitle]="title" [headerClass]="headerClass" (onClose)="cancel()"></sb-modal-header>
<div class="modal-body">
    @if (iconClass) {
        <div class="alert-dialog__icon text-center mb-2">
            <i [class]="iconClass"></i>
        </div>
    }
    @if (messageArray && messageArray.length > 0) {
        @for (item of messageArray; track item) {
            <p [innerHTML]="item | translate"></p>
        }
    } @else {
        @if (translateMessage) {
            <p [innerHTML]="message | translate:messageTranslationParameters"></p>
        } @else {
            <p [innerHTML]="message"></p>
        }
    }
</div>
<!-- Button order is intentional and matches the legacy confirmation-popup: Cancel (btn-warning) on the
     left, OK/Confirm (btn-success by default) on the right. -->
<div class="modal-footer">
    @if (cancelButtonText) {
        <button type="button" class="btn btn-warning" (click)="cancel()" [innerHTML]="cancelButtonText | translate"></button>
    }
    <button type="button" class="btn btn-success" [ngClass]="'btn-' + okButtonClass" (click)="ok()" [innerHTML]="okButtonText | translate"></button>
</div>
